import { Component, inject, OnInit } from '@angular/core';
import { HeadService } from '../../../../services/head.service';
import { CustomerService } from '../../../../services/customer.service';
import { OrderDto } from '../../../../dtos/order.dto';
import { DEFAULT_ERROR_TEXT } from '../../../../constants';
import { finalize } from 'rxjs/operators';
import { LanguageService } from '../../../../services/language/language.service';
import { environment } from '../../../../../environments/environment';
import { ShippingMethodEnum } from '../../../../enums/shipping-method.enum';
import { DatePipe } from '@angular/common';
import { PreloaderComponent } from '../../../../components/preloader/preloader.component';
import { RouterLinkWithLang } from '../../../../directives/router-link-with-lang/router-link-with-lang.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'account-orders',
  templateUrl: './account-orders.component.html',
  styleUrls: ['./account-orders.component.scss'],
  imports: [PreloaderComponent, DatePipe, TranslatePipe, RouterLink, RouterLinkWithLang],
})
export class AccountOrdersComponent implements OnInit {
  private headService = inject(HeadService);
  private customerService = inject(CustomerService);
  private languageService = inject(LanguageService);


  uploadedHost = environment.uploadedHost;
  orders: OrderDto[] = [];
  error: string;
  isLoading: boolean = false;

  ngOnInit(): void {
    this.fetchOrders();
    this.setMeta();
  }

  private fetchOrders() {
    this.isLoading = true;
    this.error = null;
    this.customerService.fetchOrders()
      .pipe( finalize(() => this.isLoading = false) )
      .subscribe(
        response => {
          this.orders = response.data;
        },
        error => this.error = error.error?.message || DEFAULT_ERROR_TEXT
      );
  }

  private setMeta() {
    this.languageService.getTranslation('global.my_orders').subscribe(text => {
      this.headService.setMeta({ title: text, description: text });
    });
  }

  isShippingMethodDelivery(order: OrderDto): boolean {
    return order.shipment.recipient.address.type === ShippingMethodEnum.WAREHOUSE
      || order.shipment.recipient.address.type === ShippingMethodEnum.DOORS;
  }
}
